var _path;
import * as React from "react";
var SvgFacebookNegativeIconinline = function SvgFacebookNegativeIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0h-29C.5 0-.3.8-.3 1.8v28.5c0 1 .8 1.8 1.8 1.8h15.6V19.6h-4.3v-4.8h4.3v-3.6c0-4.1 2.6-6.4 6.3-6.4 1.3 0 2.5.1 3.8.2v4.3h-2.6c-2 0-2.4 1-2.4 2.4v3.1h4.9l-.6 4.8h-4.2V32h8.3c1 0 1.8-.8 1.8-1.8V1.8c-.1-1-.9-1.8-1.9-1.8",
    className: "facebook-negative-icon_inline_svg__st0"
  })));
};
export default SvgFacebookNegativeIconinline;